import { getRouteApi } from '@tanstack/react-router'
import { routes } from 'commons/constants/routes'
import { Hr } from 'ui/components/Hr'
import { Page } from 'ui/components/Page'

import * as SC from './styles'

const routeApi = getRouteApi('/_app/reports')

type Reports = {
  showAlertsReport: boolean
  showApplicationPipelineReport: boolean
  showClientPortalUsersActivityReport: boolean
  showEmailHistoryReport: boolean
  showRelationshipsReport: boolean
  showComplianceReviewReport: string | null
  showSiteAuditDocumentsReport: boolean
  showUserReport: boolean
  showDocumentStatusReport: boolean
}

export const Overview = () => {
  const loaderData = routeApi.useLoaderData() as Reports
  const {
    showAlertsReport,
    showApplicationPipelineReport,
    showClientPortalUsersActivityReport,
    showEmailHistoryReport,
    showRelationshipsReport,
    showComplianceReviewReport,
    showUserReport,
    showDocumentStatusReport
  } = loaderData

  return (
    <Page title="Reports">
      <Hr />
      <SC.Buttons>
        {showClientPortalUsersActivityReport && (
          <SC.WrappedButton text="Client Portal Users Activity Report" url={routes.bank.reports.client.index} />
        )}
        {showComplianceReviewReport !== null && (
          <SC.WrappedButton text={showComplianceReviewReport} url={routes.bank.reports.siteAuditDocuments.index} />
        )}
        {showUserReport && <SC.WrappedButton text="User Report" url={routes.bank.reports.user.index} />}
        {showRelationshipsReport && (
          <SC.WrappedButton text="Relationships Report" url={routes.bank.reports.relationships.index} />
        )}
        {showApplicationPipelineReport && (
          <SC.WrappedButton text="Application Pipeline Report" url={routes.bank.reports.applicationPipeline.index} />
        )}
        {showEmailHistoryReport && (
          <SC.WrappedButton text="Email History Report" url={routes.bank.reports.emailHistoryReport.index} />
        )}
        {showAlertsReport && <SC.WrappedButton text="Alerts Report" url={routes.bank.reports.alerts.index} />}
        {showDocumentStatusReport && (
          <SC.WrappedButton text="Document Status Report" url={routes.bank.reports.documentStatus.index} />
        )}
      </SC.Buttons>
    </Page>
  )
}
